module.exports = __webpack_public_path__ + "fj.caf72f69ced8ffea30cc.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/portal/bullseye/node_modules/flag-icon-css/flags/4x3/fj.svg
// module id = ../../../../flag-icon-css/flags/4x3/fj.svg
// module chunks = styles